module.exports = new __parcel__URL__("battleroyale_results_pane_divider.6d33d53e.png").toString();